<section class="contact-dialog">
  <!-- dialog header -->
  <div class="contact-dialog__header">
    <!-- title -->
    <h4 class="contact-dialog__title">{{ title | translate }}</h4>
    <!-- close button -->
    <button (click)="close()">
      <i class="iconsax contact-dialog__icon" icon-name="x"></i>
    </button>
  </div>
  <!-- contact items list -->
  <ul class="contact-dialog__body">
    @for (contact of contactsData; track $index) {
      <li>
        <pwj-contact-item [contactData]="contact"></pwj-contact-item>
      </li>
    }
  </ul>
</section>
